import React from 'react';

import Permissions from 'mattermost-redux/constants/permissions';
import {type Emoji} from 'mattermost-redux/types/emojis';
import {Constants} from 'utils/constants';
import PostContext from 'components/post_view/post_context';
import ChannelPermissionGate from 'components/permissions_gates/channel_permission_gate';
import OverlayTrigger from 'components/overlay_trigger';
import Tooltip from 'components/tooltip';

import EmojiItem from './recent_reactions_emoji_item';

type Props = {
    channelId?: string;
    postId: string;
    teamId: string;
    getDotMenuRef: () => HTMLDivElement | null;
    locale: string;
    emojis: Emoji[];
    size: number;
    defaultEmojis: Emoji[];
    actions: {
        addReaction: (postId: string, emojiName: string) => Promise<void>;
    };
}

const POST_RECENT_REACTIONS_PERMISSIONS = [Permissions.ADD_REACTION];

export default class PostRecentReactions extends React.PureComponent<Props> {
    static contextType = PostContext;
    declare context: React.ContextType<typeof PostContext>

    public static defaultProps: Partial<Props> = {
        size: 3,
    };

    handleAddEmoji = (emoji: Emoji): void => {
        const emojiName = 'short_name' in emoji ? emoji.short_name : emoji.name;
        this.props.actions.addReaction(this.props.postId, emojiName);

        this.context.onLogPostAction('reactionRecent', 'popup');
    };

    complementEmojis = (emojis: Emoji[]): (Emoji[]) => {
        const additional = this.props.defaultEmojis.filter((e) => {
            let ignore = false;
            for (const emoji of emojis) {
                if (e.name === emoji.name) {
                    ignore = true;
                    break;
                }
            }
            return !ignore;
        });
        const l = emojis.length;
        for (let i = 0; i < this.props.size - l; i++) {
            emojis.push(additional[i]!);
        }

        return emojis;
    };

    emojiName = (emoji: Emoji, locale: string): string => {
        function capitalizeFirstLetter(s: string) {
            return s[0]!.toLocaleUpperCase(locale) + s.slice(1);
        }
        const name = 'short_name' in emoji ? emoji.short_name : emoji.name;
        return capitalizeFirstLetter(name.replace(/_/g, ' '));
    };

    render() {
        const {
            channelId,
            teamId,
        } = this.props;

        let emojis = [...this.props.emojis].slice(0, this.props.size);
        if (emojis.length < this.props.size) {
            emojis = this.complementEmojis(emojis);
        }

        return emojis.map((emoji, n) => (
            <ChannelPermissionGate
                key={this.emojiName(emoji, this.props.locale)} // emojis will be unique therefore no duplication expected.
                channelId={channelId}
                teamId={teamId}
                permissions={POST_RECENT_REACTIONS_PERMISSIONS}
            >
                <OverlayTrigger
                    className='hidden-xs'
                    delayShow={Constants.OVERLAY_TIME_DELAY}
                    placement='top'
                    overlay={
                        <Tooltip
                            id='post_info.emoji.tooltip'
                            className='hidden-xs'
                        >
                            {this.emojiName(emoji, this.props.locale)}
                        </Tooltip>
                    }
                >
                    <div>
                        <React.Fragment>
                            <EmojiItem
                                // eslint-disable-next-line react/no-array-index-key
                                emoji={emoji}
                                onItemClick={this.handleAddEmoji}
                                order={n}
                            />
                        </React.Fragment>
                    </div>
                </OverlayTrigger>
            </ChannelPermissionGate>
        ),
        );
    }
}

